import Upsertable from '@/models/Upsertable'
import { useAgriSubContractStepStore } from '@/stores/agriSubContractStepStore.js'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class AgriSubContractStep extends Upsertable {
  static store() {
    return useAgriSubContractStepStore()
  }

  store() {
    return AgriSubContractStep.store()
  }
}

useModelName(AgriSubContractStep, "AgriSubContractStep")
ModelRegistry.register(AgriSubContractStep, "AgriSubContractStep")